<template>
  <div id="app">
    <router-view/>
    <CompleteOrderResumeFloat />
  </div>
</template>

<script>
import CompleteOrderResumeFloat from "@/components/CompleteOrderResumeFloat.vue";

export default {
  components: {
    CompleteOrderResumeFloat,
  },
};
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
